// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ecNg","top":"styles_top__HTZu1","left":"styles_left__3cnl2","description":"styles_description__1ZXQh"};